import {useIonViewWillEnter, useIonViewWillLeave} from "@ionic/react";
import {useEffect, useMemo, useRef, useState} from "react";
import {Pg_6_3_Store} from "../store/Pg_6_Store";

export const usePageDataLoader = (pathanme: any = '/tabs/3_1', pageStore: any, loadingFunc: any = null) => {
    const refIsInPage = useRef<boolean | null>(null);
    const [urlInPage, setUrlInPage] = useState<string | null>(null);

    useIonViewWillEnter(() => {
        refIsInPage.current = true;

        if (urlInPage === null || urlInPage !== window.location.toString()) {
            setUrlInPage(window.location.toString());
        }
    });

    useIonViewWillLeave(() => {
        refIsInPage.current = false;
    });

    //pre-kill, so it cannot show previously loaded page
    if (typeof window !== "undefined") {
        /// browser code
        if (window.location.pathname.match(pathanme)) {
            if (urlInPage === null || urlInPage !== window.location.toString()) {
                if (urlInPage !== window.location.toString()) {
                    pageStore.replace({});
                }
            }
        }
    }

    useEffect(() => {
        if (window.location.pathname.match(pathanme)) {
            if (urlInPage === null || urlInPage !== window.location.toString()) {
                setUrlInPage(window.location.toString());
            }
        }
    }, [window.location.toString()]);

    const pageDataLoaderCtrl = useMemo(() => {
        return {
            urlInPage: urlInPage,
            refIsInPage: refIsInPage,

            loadingFunc: loadingFunc,
        }
    }, [urlInPage]);

    useEffect(() => {
        if (urlInPage == null) { //skip
            return;
        }

        loadingFunc?.();
        // (async () => {
        //     const {contractId = null, userId = null, isBookmark = null, isMy = null}: {
        //         contractId: string | null,
        //         userId: string | null,
        //         isBookmark: string | null,
        //         isMy: string | null,
        //     } = queryString.parse(window.location.search) as any;
        //     let errorObj = await fetch_pg_3_1({
        //         p1: contractId,
        //         p2: userId,
        //         p3: !!isBookmark,
        //         p4: !!isMy,
        //     });
        //     handleCommonFetchErrors(router, errorObj);
        // })();
    }, [urlInPage]);

    return {
        pageDataLoaderCtrl
    };
}
